import React from 'react';

interface StartTherapyCardProps {
  onBook?: () => void;
  /** URL для кнопки «Umów konsultację — 199 zł» */
  bookUrl?: string;
}

/**
 * StartTherapyCard — картка для «холодного старту» (сценарій 5 прототипу).
 * Показується коли пацієнтка купила тільки послуги дієтолога,
 * але ще не має жодної лікарської консультації.
 *
 * З прототипу: .card--start { background: #fff; border: 1px solid #D6C1F1 }
 */
export const StartTherapyCard: React.FC<StartTherapyCardProps> = ({
  onBook,
  bookUrl = '/teleporada-leczenie-otylosci/',
}) => {
  const STYLES = `
    .stc-card {
      background: #fff; border: 1px solid #D6C1F1; border-radius: 24px;
      padding: 16px; margin-bottom: 12px;
    }
    .stc-rowc { display: flex; align-items: flex-start; gap: 8px; }
    .stc-iconc {
      width: 40px; height: 40px; flex: none; border-radius: 32px;
      background: #F3EEFC; display: flex; align-items: center; justify-content: center;
    }
    .stc-rowtxt { flex: 1; min-width: 0; }
    .stc-title {
      font-size: 16px; font-weight: 600; line-height: 140%; color: #361777;
      margin: 0 0 4px;
    }
    .stc-sub {
      font-size: 12px; font-weight: 500; line-height: 140%; color: #786798; margin: 0;
    }
    .stc-btn {
      display: flex; align-items: center; justify-content: center; width: 100%; height: 54px;
      border-radius: 100px; background: #361777; color: #fff; border: none;
      font-size: 16px; font-weight: 500; margin-top: 16px; cursor: pointer;
      font-family: inherit; text-decoration: none; transition: opacity .15s;
    }
    .stc-btn:active { opacity: .85; }
  `;

  const handleClick = () => {
    if (onBook) {
      onBook();
    } else {
      window.location.href = bookUrl;
    }
  };

  return (
    <>
      <style>{STYLES}</style>
      <div className="stc-card">
        <div className="stc-rowc">
          <div className="stc-iconc">
            {/* heart icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20l-7-7a4 4 0 0 1 6-5l1 1 1-1a4 4 0 0 1 6 5z" />
            </svg>
          </div>
          <div className="stc-rowtxt">
            <p className="stc-title">Zacznij terapię pod opieką lekarza</p>
            <p className="stc-sub">
              Konsultacja online — lekarz dobierze leczenie GLP-1 i poprowadzi Cię krok po kroku
            </p>
          </div>
        </div>
        <button className="stc-btn" onClick={handleClick}>
          Umów konsultację — 199 zł
        </button>
      </div>
    </>
  );
};
